import { useEffect } from 'react';
import { useProject } from '../../project-hooks/useProject';
import { fetchCauseForProject } from '../../../template/template-actions';
import { useDispatch, useSelector } from 'react-redux';
import { isProjectADugnad } from '../../project-model';
import { getCauseForProjectId } from '../../../template/template-reducer';
import { fetchOrganization } from '../../../organization/organization-actions';
import { CampaignBanner } from '../../../campaign-banner/CampaignBanner';
import styles from './project-cause-banner.module.less';

const ProjectCauseBanner = () => {
    const dispatch = useDispatch();
    const project = useProject();
    const { receiverInformation } = project;
    const templateCause = useSelector((state) => getCauseForProjectId(state, project?.id));

    useEffect(() => {
        if (project?.template_id) {
            dispatch(fetchCauseForProject({ projectId: project.id }));
        }
    }, [dispatch, project.id, project?.template_id]);

    useEffect(() => {
        if (templateCause?.organization_id) {
            dispatch(fetchOrganization(templateCause.organization_id));
        }
    }, [dispatch, templateCause?.organization_id]);

    if (!templateCause?.id) {
        return null;
    }

    const bannerText = `${isProjectADugnad(project) ? 'Dugnaden' : 'Spleisen'} er en del av`;
    const linkTo = templateCause?.profile?.overrideBanner?.linkTo || `/cause/${templateCause.id}`;
    const imageUrl = templateCause?.profile?.overrideBanner?.imageUrl || receiverInformation?.imageSource;

    return (
        <CampaignBanner
            className={styles.banner}
            imageUrl={imageUrl}
            text={bannerText}
            linkTo={linkTo}
            linkText={templateCause.title}
        />
    );
};

export default ProjectCauseBanner;
